<template>
    <div class="container" v-title="'新增代表队'">
        <Navigation-bar :title="navBarTitle"></Navigation-bar>
         <div class="container_content" v-if="pageShow">
             <div id="AddTeam" v-scroll="scrollTop">
                <Title :title="pageText.title" subtitle="填写代表队报名信息"></Title>
                <div class="AddTeam_content">
                    <Fold label="1.比赛项目" 
                        :text="events.name" 
                        :unfold="unfoldId == 1" 
                        :error="requiredId == 1"
                        :required="true"
                        :disabled="!isNew"
                        @unfold-change="unfoldChange(...arguments,1)"
                    >
                        <div>
                            <Option v-for="(item,index) in events.list" :key="index"
                                :active="item.Id == events.id"
                                @click="selectEvents(item.Name,item.Id)"
                            >{{item.Name}}</Option>
                        </div>
                    </Fold>
                    <Fold label="2.代表队名称" 
                        :text="isNew ? team.name : team.nameVal" 
                        :unfold="unfoldId == 2" 
                        :error="requiredId == 2"
                        :required="true"
                        @unfold-change="unfoldChange(...arguments,2)"
                    >
                        <Input v-model.trim="team.nameVal" :focus="unfoldId == 2" placeholder="请填写代表队名称" @blur="checkDeputationName()"></Input>
                        <div class="filtrate_content" v-if="isNew">
                            <div class="filtrate_list" >
                                <ul v-show="team.list.length > 0" v-for="(item,index) in team.list" :key="index" >
                                    <li v-if="item.CompanyName" @click="selectTeam(item)" v-html="textSign(item.DeputationName,1)+`（${item.CompanyName}）`"></li>
                                    <li v-else @click="selectTeam(item)" v-html="textSign(item.DeputationName,1)"></li>
                                </ul>
                                <p class="load_more" v-show="team.loadMore">{{team.loadMore}}</p>
                                <div class="noData" v-show="team.name != team.nameVal && !team.loadMore && team.list.length == 0">
                                    <span>尚未创建的代表队</span>
                                </div>
                            </div>
                            <button v-href="'/Enroll/CreateTeam?subLeagueId=' + subLeagueId + '&eventsId=' + this.events.id + '&teamName=' + this.team.nameVal" style="color: #7AD21A;">
                                <span>创建代表队</span>
                                <YD-image src="icon/icon_card_arrow_2"></YD-image>
                            </button>
                        </div>
						<div class="error_message" v-else>{{errorMessage}}</div>
                    </Fold>
                    <Fold label="3.代表机构" 
                        :text="company.name" 
                        :unfold="unfoldId == 3" 
                        :error="requiredId == 3"
                        :required="true"
                        @unfold-change="unfoldChange(...arguments,3)" 
                    >
                        <Option :active="company.id == -1" @click="selectNoCompany()">无</Option>
                        <Input v-model.trim="company.nameVal" placeholder="请填写代表机构名称"></Input>
                        <div class="filtrate_content">
                            <div class="filtrate_list" >
                                <ul v-show="company.list.length > 0">
                                    <li v-for="(item,index) in company.list" :key="index" 
                                        @click="selectCompany(item.CompanyName, item.CompanyId)"
                                        v-html="textSign(item.CompanyName,2)"
                                    ></li>
                                </ul>
                                <p class="load_more" v-show="company.loadMore">{{company.loadMore}}</p>
                                <div class="noData" v-show="company.id != -1 && company.name != company.nameVal && !company.loadMore && company.list.length == 0">
                                    <span>尚未注册的机构</span>
                                </div>
                            </div>
                            <button v-href="'/Account/AgencyRegistration'" style="color: #FFA61C;">
                                <span>机构注册</span>
                                <YD-image src="icon/icon_card_arrow_3"></YD-image>
                            </button>
                        </div>
                    </Fold>
                    <button id="submit" @click="submit()">完成</button>
                </div>
             </div>
         </div>
    </div>
</template>
<script>
import Fold from './components/Fold.vue';
import Input from './components/Input.vue';
import Option from './components/Option.vue';
import {
    convertSize
} from '@js';
import {
    GetLeagueGroupEvents,
    GetDeputationList,
    GetCompanyPageList,
    CreateDeputationEnroll,
    GetDeputationEnrollDeputationInfo,
    IsDeputationNameRepeat,
    AlterLeagueEnrollDeputationInfo
} from '@/api';
export default {
    name:"AddTeam",
    components:{
        Fold,
        Input,
        Option
    },
    data(){
        return {
            subLeagueId: 0,
            scrollTop:0,
            unfoldId:0,
            requiredId:0,
            pageShow: false,
            events:{
                id:0,
                name:"",
                list:[]
            },
            team:{
                id:0,
                name:"",
                nameVal:"",
                list:[],
                loadMore:""
            },
            company:{
                id:0,
                name:"",
                nameVal:"",
                list:[],
                loadMore:""
            },
            errorMessage: ''
        }
    },
    created(){
        this.subLeagueId = +this.$route.query.subLeagueId || 0;
		this.deputationEnrollId = +this.$route.query.deputationEnrollId || 0;
		this.getEventsList();
		if(this.deputationEnrollId){
			this.getDeputationDetail();
			this.unfoldId = 2;
		}
    },
    activated(){
        this.scrollTop -= 0.001;
        if(sessionStorage.getItem('createTeam')){
            var obj = JSON.parse(sessionStorage.getItem('createTeam'));
            sessionStorage.removeItem('createTeam');
            if(obj.eventsId == this.events.id){
                this.selectTeam({
                    DeputationId: obj.id,
                    DeputationName: obj.name,
                    CompanyId: obj.companyId,
                    CompanyName: obj.companyName
                })
            }
        }
        if(sessionStorage.getItem('createCompany')){
            var obj = JSON.parse(sessionStorage.getItem('createCompany'));
            sessionStorage.removeItem('createCompany');
            this.selectCompany(obj.name,obj.id);
        }
    },
    computed: {
        titleH(){
            return convertSize(1.08);
        },
		pageText(){
			if(this.isNew){
				return {
					title: '新增代表队'
				}
			}else{
				return {
					title: '修改代表队信息'
				}
			}
		},
		navBarTitle(){
			return this.titleHeight < this.scrollTop ? this.pageText.title : '';
		},
		isNew(){
			return !this.deputationEnrollId;
		}
    },
    watch:{
        'team.nameVal':{
            deep:true,
            handler(newVal){
				if(this.isNew){
                    if(newVal && newVal != this.team.name){
                        this.getTeamList(newVal);
                    }else{
                        this.team.loadMore = '';
                        this.team.list = [];
                    }
                }else{
					this.errorMessage = '';
				}
            }
        },
        'company.nameVal':{
            deep:true,
            handler(newVal){
                if(newVal && newVal != this.company.name){
                    this.company.id = 0;
                    this.company.name = "";
                    this.getCompanyList(newVal);
                }else{
                    this.company.loadMore = '';
                    this.company.list = [];
                    if(!newVal){
                        this.company.id = 0;
                        this.company.name = "";
                    }
                }
            }
        }
    },
    methods:{
        unfoldChange(e, unfold, unfoldId){
            if(!unfold){
                this.unfoldId = 0;
            }else{
                this.unfoldId = unfoldId;
            }
        },
		//添加未填写、错误标记
		addRequired(ID){
			this.unfoldId = ID;
			this.requiredId = 0;
			this.$nextTick(function(){
				this.requiredId = ID;
			})
		},
		getEventsList(){
            GetLeagueGroupEvents({
                SubLeagueId: this.subLeagueId
            }).then(data=>{
                if(data.Code == 0){
                    this.events.list = data.EventsList;
					if(this.isNew){
						this.pageShow = true;
                        let obj = data.EventsList[0];
                        this.events.id = obj.Id;
                        this.events.name = obj.Name;
                    }
                }
            })
		},
		getDeputationDetail(){
			GetDeputationEnrollDeputationInfo({
				DeputationEnrollId: this.deputationEnrollId
			}).then(data=>{
				this.pageShow = true;
				if(data.Code == 0){
					let {
						EventsId,
						EventsName,
						DeputationId,
						DeputationName,
						CompanyId,
						CompanyName
					} = data.EnrollDeputation;
					this.events.id = EventsId;
					this.events.name = EventsName;
					this.team.id = DeputationId;
					this.team.nameVal = DeputationName;
					this.company.id = CompanyId || -1;
					this.company.name = CompanyName || '';
					this.company.nameVal = CompanyName || '';
				}
			})
		},
        getTeamList(name){
            this.team.list = [];
            this.team.loadMore = '正在查询···';
            GetDeputationList({
                Continuation: {
                    LastId: 0,
                    MaxCount: 20
                },
                DeputationName: name,
                EventsId: this.events.id
            }).then(data=>{
                if(name == this.team.nameVal){
                    this.team.loadMore = '';
                    if(data.Code == 0){
                        this.team.list = data.ContinueList || [];
                    }
                }
            }).catch(()=>{
                this.team.loadMore = '';
            })
        },
		checkDeputationName(){
			if(this.isNew) return;
			IsDeputationNameRepeat({
				"EventsId": this.events.id,
				"DeputationName": this.team.nameVal,
				"ExceptDeputationId": this.team.id
			}).then(data=>{
				if(data.Code == 0 && data.IsRepeat){
					this.errorMessage = '代表队名称已被占用，请修改。';
					this.unfoldId = 2;
				}
			})
		},
        selectEvents(name,id){
            this.events.id = id;
            this.events.name = name;
            this.unfoldId = 2;
        },
        selectTeam(obj){
            this.team.id = obj.DeputationId;
            this.team.name = obj.DeputationName;
            this.team.nameVal = obj.DeputationName;
            this.unfoldId = 0;
            if(this.company.id == 0){
                this.company.id = obj.CompanyId;
                this.company.name = obj.CompanyName;
                this.company.nameVal = obj.CompanyName;
            }
        },
        selectNoCompany() {
            this.company.nameVal = '';
            this.$nextTick(function(){
                this.company.id = -1;
                this.company.name = "无";
                this.company.loadMore = '';
                this.company.list = [];
                this.unfoldId = 0;
            });
        },
        getCompanyList(name){
            this.company.list = [];
            this.company.loadMore = '正在查询···';
            GetCompanyPageList({
                Continuation: {
                    LastId: 0,
                    MaxCount: 20
                },
                CompanyName: name,
                AuditStatus: null
            }).then(data=>{
                if(name == this.company.nameVal){
                    this.company.loadMore = '';
                    if(data.Code == 0){
                        this.company.list = data.ContinueList || [];
                    }
                }
            }).catch(()=>{
                this.company.loadMore = '';
            })
        },
        selectCompany(name,id){
            this.company.id = id;
            this.company.name = name;
            this.company.nameVal = name;
            this.unfoldId = 0;
        },
        textSign(value,type){
            var nameVal = "";
            if(type == 1){
                nameVal = this.team.nameVal;
            }else{
                nameVal = this.company.nameVal; 
            }
            const reg = new RegExp(nameVal,'gi');
            return value.replace(reg,(matching)=>{
                return `<i style="font-style: normal;color: #7AD21A">${matching}</i>`;
            });
        },
        submit(){
            var ID = 0,
                error = "";
            if(this.isNew){
                if(this.events.id == 0){
                    ID = 1;
                    error = "请选择比赛项目";
                }else if(this.team.id == 0){
                    ID = 2;
                    error = "请选择代表队";
                }else if(this.company.id == 0){
                    ID = 3;
                    error = "请输入代表机构或选择“无”";
                }
            }else{
                if(!this.team.nameVal){
                    ID = 2;
                    error = "请选择代表队";
                }else if(this.company.id == 0){
                    ID = 3;
                    error = "请输入代表机构或选择“无”";
                }
            }
            if(ID > 0){
                this.addRequired(ID)
                this.$Toast(error, 'error');
            }else{
				if(this.isNew){
                    CreateDeputationEnroll({
                        "EnrollInfo": {
                            "DeputationEnrollId": 0,
                            "DeputationId": this.team.id,
                            "DeputationName": this.team.name,
                            "CompanyId": this.company.id == -1 ? null : this.company.id,
                            "CompanyName": this.company.id == -1 ? '' : this.company.name,
                            "EventsId": this.events.id,
                            "EventsName": this.events.name,
                            "SubLeagueId": this.subLeagueId
                        }
                    }).then(data=>{
                        if(data.Code == 0){
                            this.$Toast('代表队添加成功','success');
                            sessionStorage.setItem('addTeam',"1");
                            setTimeout(()=>{
                                this.$navigation.back();
                            },500)
                        }
                    })
                }else{
                    AlterLeagueEnrollDeputationInfo({
						"DeputationEnrollId": this.deputationEnrollId,
						"DeputationName": this.team.nameVal,
						"CompanyId": this.company.id == -1 ? null : this.company.id
                    }).then(data=>{
                        if(data.Code == 0){
                            this.$Toast('代表队修改成功','success');
                            sessionStorage.setItem('editDeputation',"1");
                            setTimeout(()=>{
                                this.$navigation.back();
                            },500)
                        }
                    })
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
#AddTeam{
    position: relative;
    .AddTeam_content{
        padding: 0 40px;
        box-sizing: border-box;
    }
}
.error_message{
	height: 34px;
	font-weight: 400;
	font-size: 24px;
	color: #FF5F2A;
	line-height: 34px;
}
.filtrate_content{
    width: 100%;
    height: 308px;
    padding-top: 40px;
    box-sizing: border-box;
    .filtrate_list{
        height: calc(100% - 84px);
        overflow-y: auto;
        margin-bottom: 40px;
        ul li{
            min-height: 40px;
            font-size: 28px;
            color: #8B8C8D;
            line-height: 40px;
            font-weight: 400;
            padding: 0 32px;
            box-sizing: border-box;
            margin-bottom: 32px;
            &:last-of-type{
                margin-bottom: 0;
            }
        }
    }
    .noData{
        height: calc(100% - 84px);
        font-size: 28px;
        color: #8B8C8D;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 40px;
    }
    >button{
        height: 44px;
        font-size: 32px;
        color: #FFA61C;
        font-weight: 500;
        line-height: 44px;
        display: flex;
        align-items: center;
        margin: 0 auto;
        img{
            width: 32px;
            height: 32px;
            margin-left: 4px;
        }
    }
}
#submit{
    @include submit-button;
}
</style>